<template>
  <NavBar
    ref="nav-bar"
    :active.sync="active"
    :create_router_to="{name: 'newFeature', params : release && release.id ? {releaseId: release.id } : '' }"
    :create_text="$t('Releases.AddFunction')"
    :items="features"
    :loading="loading"
    :types="reverse_releases"
    @filterItems="choeseRelease">
    <template #btnCreate>
      <ButtonWithMenu
        v-if="$acl.check('onlyTenders')"
        ref="buttonWithMenu"
        :label="$t('Releases.AddFunction')"
        :mini="mini"
        :router-to="{name: 'newFeature', params : release && release.id ? {releaseId: release.id } : '' }">
        <div>
          <MenuItem
            data-qa="publish-current-release"
            icon="continue"
            :label="$t('Releases.PublishCurrentRelease')"
            @click="publishRelease"/>
          <CreateRelease
            v-if="release && !release.isPublished"
            :release="release"
            @choeseRelease="choeseRelease"/>
          <MenuItem
            data-qa="delete-release"
            icon="delete"
            :label="$t('Releases.DeleteRelease')"
            @click="deleteRelease"/>
          <CreateRelease @choeseRelease="choeseRelease"/>
        </div>
      </ButtonWithMenu>
    </template>
    <template #list_item="{ item }">
      <div
        class="type-name pr-1"
        :class="item.isPublished ? ' green--text ': ''">
        {{ item.publishName }}
      </div>
      <div class="type-count">
        {{ item.count }}
      </div>
    </template>
  </NavBar>
</template>

<script>
import MenuItem from 'components/common/MenuItem.vue'
import NavBar from 'components/common/blocks/NavBar.vue'
import CreateRelease from 'components/releases/CreateRelease.vue'
import ButtonWithMenu from 'components/common/elements/ButtonWithMenu.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'releasesNavBar',
  data() {
    return {
      active: 0,
      active_fiter: false,
    }
  },
  props: {
    releases: Array,
    release: Object,
    mini: Boolean,
    loading: Boolean
  },
  computed: {
    ...mapGetters({
    }),
    reverse_releases() {
      if (!this.releases) {
        return []
      }
      return this.releases.slice(0)
        .sort((a,b) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()
          || a.id - b.id)
    },
    features() {
      return this.release?.features || []
    }
  },
  methods: {
    closeMenu() {
      this.$refs.buttonWithMenu.closeMenu()
    },
    choeseRelease(item) {
      this.closeMenu()
      let index = this.reverse_releases.findIndex(el => el.id == item?.id)
      this.active = index == -1 ? 0 : index
      this.$emit('update:release', this.reverse_releases[index] || {})
    },
    deleteRelease() {
      this.closeMenu()
      this.$emit('update:loading', true)
      this.$store.dispatch('deleteRelease', this.release)
        .finally(() => {
          this.$emit('update:loading', false)
        })
      this.active = 0
      /*
      this.$emit('update:release', this.releases[0] || {})
      this.$refs['nav-bar'].active = 0
      */
    },
    publishRelease() {
      if (this.release.isPublished) {
        return
      }
      this.closeMenu()
      this.$store.dispatch('changeRelease', {...this.release, isPublished: true} )
      // this.$emit('update:release', this.releases[0] || {})
    }
  },
  components: {
    NavBar,
    MenuItem,
    CreateRelease,
    ButtonWithMenu
  }
}
</script>
<style lang="scss" scoped>
.btn-create {
  background: var(--black-color);
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  height: 40px;
  margin: 0 10px;
  color: var(--v-main__light_green-base) !important;
  &.is-min {
    width: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  &__btn {
    margin: auto 0;
    line-height: 22px;
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    color: var(--v-main__light_green-base) !important;
    &:hover,
    &:focus {
      opacity: 0.5;
    }
  }
  &__menu {
    height: 100%;
    padding: 0 15px 0 0;
    line-height: 22px;
    font-size: 14px;
    display: flex;
    &::v-deep {
      &:hover .s-popover__reference-wrapper,
      &:focus .s-popover__reference-wrapper {
        opacity: 0.8;
      }
      .s-popover__reference-wrapper {
        margin: auto;
      }
    }
  }
}
</style>
